import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import BaseLink from '@/components_new/BaseLink.vue'
import Typography from '@/components_new/Typography.vue'
import { ROUTE_NAMES } from '@/router/constants'

import RobloxLogoIcon from './images/roblox-logo.svg'

export default /*@__PURE__*/_defineComponent({
  __name: 'RewardsWidget',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseLink, {
    class: _normalizeClass(_ctx.$style.rewards),
    to: { name: _unref(ROUTE_NAMES).SHOP },
    "data-interface-target": "shop-link"
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createTextVNode(" > ")),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.cards)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.card, _ctx.$style.card1])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.card, _ctx.$style.card2])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.card, _ctx.$style.card3])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.card_shine)
          }, null, 2),
          _createElementVNode("img", {
            src: _unref(RobloxLogoIcon),
            class: _normalizeClass(_ctx.$style.card_icon),
            alt: "Roblox",
            loading: "lazy"
          }, null, 10, _hoisted_1)
        ], 2)
      ], 2),
      _createVNode(Typography, {
        type: "label",
        size: "l",
        semibold: "",
        responsive: false
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$tr('rewards.title')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class", "to"]))
}
}

})